import { render, staticRenderFns } from "./CnpjInput.vue?vue&type=template&id=329a889e&"
import script from "./CnpjInput.vue?vue&type=script&lang=js&"
export * from "./CnpjInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports